import React from 'react';
import { Play, Calendar } from 'lucide-react';
import { TinyAd } from '@/components/TinyAd';

/// Worldwide accessible highlights (updated January 15, 2026)
// Featuring latest AFCON 2025 highlights from CAF / SuperSport / globally viewable YouTube
const highlights = [
    {
    id: '22',
    title: 'Senegal vs Morocco | AFCON 2025 Final Extended Highlights',
    videoId: 'VBHgYnTCqIQ', // Extended highlights of the AFCON 2025 final (Senegal wins 1-0 AET) :contentReference[oaicite:0]{index=0}
    thumbnail: 'https://img.youtube.com/vi/VBHgYnTCqIQ/maxresdefault.jpg',
    date: '2026-01-18',
    source: 'CAF / Global Highlights',
  },
  {
    id: '23',
    title: 'Senegal vs Morocco | Key Moments & Controversy Highlights',
    videoId: '2Ac7w05opys', // Crucial calls & disallowed goal moments from the final :contentReference[oaicite:1]{index=1}
    thumbnail: 'https://img.youtube.com/vi/2Ac7w05opys/maxresdefault.jpg',
    date: '2026-01-18',
    source: 'Official Football Highlights',
  },
  {
    id: '24',
    title: 'Senegal are Champions of AFCON 2025 | beIN SPORTS Highlights',
    videoId: 'XAY3vOgoNZc', // Title celebration & goal for Senegal (1-0) :contentReference[oaicite:2]{index=2}
    thumbnail: 'https://img.youtube.com/vi/XAY3vOgoNZc/maxresdefault.jpg',
    date: '2026-01-18',
    source: 'beIN SPORTS',
  },
  {
    id: '21',
    title: 'Morocco vs Nigeria | AFCON 2025 Semi-Final Highlights',
    videoId: '8rVYcW0-oh0', // extended highlights of the semi-final (Morocco wins on penalties) :contentReference[oaicite:0]{index=0}
    thumbnail: 'https://img.youtube.com/vi/8rVYcW0-oh0/maxresdefault.jpg',
    date: '2026-01-14',
    source: 'CAF Highlights',
  },
  {
    id: '20',
    title: 'Senegal vs Egypt | AFCON 2025 Semi-Final Highlights',
    videoId: 'Kd1CQx0Fu7M', // Senegal goal and action from semi-final (Mané winner) :contentReference[oaicite:1]{index=1}
    thumbnail: 'https://img.youtube.com/vi/Kd1CQx0Fu7M/maxresdefault.jpg',
    date: '2026-01-14',
    source: 'CAF Highlights',
  },
  {
    id: '19',
    title: 'Mali vs Senegal | AFCON 2025 Quarter-Final Highlights',
    videoId: 'sGyzkaN5gSs', // SuperSport highlights reel for Senegal vs Mali :contentReference[oaicite:2]{index=2}
    thumbnail: 'https://img.youtube.com/vi/sGyzkaN5gSs/maxresdefault.jpg',
    date: '2026-01-09',
    source: 'SuperSport',
  },
  {
    id: '14',
    title: 'Egypt vs Côte d’Ivoire | AFCON 2025 Quarter-Final Highlights',
    videoId: '8Uj0loC30i0',
    thumbnail: 'https://img.youtube.com/vi/8Uj0loC30i0/maxresdefault.jpg',
    date: '2026-01-10',
    source: 'CAF TV',
  },
  {
    id: '13',
    title: 'Nigeria vs Algeria | AFCON 2025 Quarter-Final Highlights',
    videoId: '7fmk5Bg7iu8',
    thumbnail: 'https://img.youtube.com/vi/7fmk5Bg7iu8/maxresdefault.jpg',
    date: '2026-01-10',
    source: 'CAF TV',
  },
  {
    id: '1',
    title: 'Cameroon vs Morocco | AFCON 2025 Quarter-Final Highlights',
    videoId: 'dFmH01A9Q9M',
    thumbnail: 'https://img.youtube.com/vi/dFmH01A9Q9M/maxresdefault.jpg',
    date: '2026-01-09',
    source: 'CAF TV',
  },
  {
    id: '2',
    title: 'Senegal vs Mali | AFCON 2025 Quarter-Final Highlights',
    videoId: 'LC-tUuMjZCk',
    thumbnail: 'https://img.youtube.com/vi/LC-tUuMjZCk/maxresdefault.jpg',
    date: '2026-01-09',
    source: 'CAF TV',
  },
  {
    id: '3',
    title: 'South Africa vs Cameroon | AFCON 2025 Round of 16 Highlights',
    videoId: 'kp5QyEBb4Ag',
    thumbnail: 'https://img.youtube.com/vi/kp5QyEBb4Ag/maxresdefault.jpg',
    date: '2026-01-04',
    source: 'CAF TV',
  },
  {
    id: '4',
    title: 'Nigeria vs Mozambique | AFCON 2025 Round of 16 Highlights',
    videoId: 'etAdbPrS9rk',
    thumbnail: 'https://img.youtube.com/vi/etAdbPrS9rk/maxresdefault.jpg',
    date: '2026-01-05',
    source: 'CAF TV',
  },
  {
    id: '5',
    title: 'Egypt vs Benin | AFCON 2025 Round of 16 Highlights',
    videoId: 'IQZmaOa83wM',
    thumbnail: 'https://img.youtube.com/vi/IQZmaOa83wM/maxresdefault.jpg',
    date: '2026-01-05',
    source: 'CAF TV',
  },
  {
    id: '6',
    title: 'Zambia vs Morocco | AFCON 2025 Group Stage Highlights',
    videoId: '7vXH5_5KAdk',
    thumbnail: 'https://img.youtube.com/vi/7vXH5_5KAdk/maxresdefault.jpg',
    date: '2025-12-29',
    source: 'CAF TV',
  },
  {
    id: '7',
    title: 'Morocco vs Comoros | AFCON 2025 Group Stage Highlights',
    videoId: 's0PKW8xzPao',
    thumbnail: 'https://img.youtube.com/vi/s0PKW8xzPao/maxresdefault.jpg',
    date: '2025-12-21',
    source: 'SuperSport',
  },
];



const HighlightCard = ({ highlight, isFeatured = false }) => {
  const formattedDate = new Date(highlight.date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className={`group bg-gray-900/70 backdrop-blur-sm border border-gray-800 rounded-xl overflow-hidden
                    hover:border-gray-600 transition-all duration-300 hover:shadow-xl hover:shadow-black/40
                    ${isFeatured ? 'shadow-2xl shadow-emerald-900/30' : ''}`}>
      <div className="relative aspect-video overflow-hidden">
        <img
          src={highlight.thumbnail}
          alt={highlight.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        
        <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100 transition">
          <div className="bg-emerald-600/90 backdrop-blur-sm rounded-full p-4 transform scale-90 group-hover:scale-100 transition">
            <Play className="w-8 h-8 sm:w-10 sm:h-10 text-white fill-white" />
          </div>
        </div>

        <div className="absolute top-3 left-3">
          <span className="bg-black/70 backdrop-blur-sm text-white text-xs font-medium px-2.5 py-1 rounded-full border border-gray-700">
            {highlight.source}
          </span>
        </div>
      </div>

      <div className="p-4 sm:p-5">
        <h3 className={`font-bold text-white ${isFeatured ? 'text-xl sm:text-2xl' : 'text-base sm:text-lg'} mb-2 line-clamp-2`}>
          {highlight.title}
        </h3>
        <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-400">
          <Calendar size={16} />
          <span>{formattedDate}</span>
        </div>
      </div>

      <a
        href={`https://www.youtube.com/watch?v=${highlight.videoId}`}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute inset-0"
        aria-label={`Watch ${highlight.title}`}
      />
    </div>
  );
};

export const HighlightsPage = () => {
  const featured = highlights[0]; // Latest Morocco home win as featured!
  const recent = highlights.slice(1);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-black to-gray-950 text-white pb-16">
      <div className="container mx-auto px-4 sm:px-6 pt-8 md:pt-12 lg:pt-16">
        <div className="text-center mb-10 md:mb-16">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-teal-400 mb-4">
            AFCON 2025 Highlights
          </h1>
          <p className="text-gray-400 text-lg sm:text-xl max-w-3xl mx-auto">
            SuperSport / CAF TV & verified global sources • Worldwide access • Updated Jan 15, 2026
          </p>
        </div>

        {featured && (
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 md:mb-8 flex items-center gap-3">
              <span className="text-emerald-400">★</span> Featured: Great AFCON!
            </h2>

            {/* Only the big player, full width */}
            <div className="bg-gray-900/70 backdrop-blur-md border border-gray-800 rounded-2xl overflow-hidden shadow-2xl max-w-4xl mx-auto">
              <div className="aspect-video">
                <iframe
                  src={`https://www.youtube.com/embed/${featured.videoId}?rel=0&modestbranding=1`}
                  title={featured.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
              <div className="p-5">
                <h3 className="text-xl sm:text-2xl font-bold mb-3">{featured.title}</h3>
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <Calendar size={16} />
                  <span>
                    {new Date(featured.date).toLocaleDateString('en-US', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </span>
                </div>
              </div>
            </div>
          </section>
        )}

        <section className="mb-16 md:mb-20">
          <h2 className="text-2xl sm:text-3xl font-bold mb-6 md:mb-8">Recent Highlights</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6 lg:gap-8">
            {recent.map((highlight) => (
              <HighlightCard key={highlight.id} highlight={highlight} />
            ))}
          </div>
        </section>
        <TinyAd />
        <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-8 text-center">
          <p className="text-sm sm:text-base text-gray-300">
            Videos from verified YouTube sources (mainly SuperSport & CAF TV official channels)<br className="hidden sm:inline" />
            <span className="text-emerald-400">✓ Worldwide accessible • High quality • More official uploads expected soon!</span>
          </p>
        </div>
      </div>
    </div>
  );
};